(window as any).NP._currentCulture = (window as any).NP.EN_Culture = {
	Name: 'en',
	LCID: 1033,
	DisplayName: "English",
	DayNames: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
	ShortDayNames: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
	MonthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	ShortMonthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	TimeSeparator: ":",
	DateSeparator: "/",
	DecimalSeparator: ".",
	GroupSeparator: ",",
	Resources: {
		"Refresh": "Refresh",
		"Attempts": "Attempts",
		"All": "All",
		"Desc": "Descending",
		"Details": "Details",
		"Delete": "Delete",
		"AreYouS": "Are you sure?",
		"Asc": "Ascending",
		"Back": "Back",
		"by": "by",
		"Count": "Count",
		"count": "Row count",
		"Description": "Description",
		"Done": "Done",
		"DontSave": "Dont save",
		"Edit": "Edit",
		"Email": "Email",
		"Language": "Language",
		"me": "me",
		"Me": "Me",
		"New": "New",
		"NewPassword": "Password",
		"NewPwd": "Please, enter the password",
		"None": "None",
		"Options": "Options",
		"Order": "Order",
		"Password": "Password",
		"Remove": "Remove",
		"SaveAsPDF": "Save as PDF",
		"SaveChanges": "Save changes?",
		"SaveChanges2": "Save changes",
		"Sec": "sec",
		"Sort": "Sort",
		"SortBy": "Sort by",
		"SortBy3Dot": "Sort by...",
		"Sorting": "Sorting",
		"SortName": "Name",
		"SortOptions": "Sort options",
		"Users": "Users",
		"Status": "Status",
		"Confirm": "Confirm",
		"Close": "Close",
		"Ok": "Ok",
		"Cancel": "Cancel",
		"SignOut": "Sign out",
		"SignIn": "Sign in",
		'Save': 'Save',
		"Parameters": "Parameters",
		"CreateTeam": "Create team",
		"TotalDiamonds": "Total Diamonds",
		"Diamonds": "Diamonds",
		"Space": "Space",
		"No": "No",
		"Date": "Date",
		"Name": "Name",
		"LogInAsUser": "Login as user",
		"ChangeEmail": "Change Email",
		"ChangeEmailConfirm": "Change email from {0} to {1}?",
		"Settings": "Settings",
		"FirstName": "First name",
		"LastName": "Last name",
		'ExcludeBattleFromVideo': 'Exclude from result video',
		'StartCreateVideo': 'Start create video',
		'VideEventHighlights': 'Video Event Highlights',
		'Download': 'Download',
		'Features': 'Features',
		'VideoStreamRecording': 'Video stream recording: ',
		'DownloadBattleVideo': 'Download recording video',

		"SportType": "Sport type",
		"MMA Athletes": "Athletes",
		"Boxers": "Boxers",
		"Regions": "Regions",
		"AllTournaments": "All tournaments",
		"Association": "Association",
		"Athletes": "Boxers",
		"Battle": "Battle",
		"BattleLockMessage": "This battle already locked by ",
		"BattleResults": "Battle results",
		"Blue": "Blue",
		"Boxer": "Boxer",
		"SelectBoxer": "Select athlete",
		"City": "City",
		"Coaches": "Coaches",
		"DateBirth": "Date birth",
		"Efficiency": "Efficiency",
		"EnterPersonalCabinet": "Enter personal cabinet",
		"FemaleGender": "Women",
		"FemaleSex": "Female",
		"Gender": "Gender",
		"InDevelopment": "This section is under construction...",
		"Judge": "Judge",
		"Kilogram": "kg",
		"MaleGender": "Men",
		"MaleSex": "Male",
		"Qualification": "Qualification",
		"Rating": "Overall rating",
		"Red": "Red",
		"Refereeing": "R&J",
		"Region": "Region",
		"Sex": "Sex",
		"SortByDate": "Date",
		"SortByResult": "Result",
		"SortByBlue": "Blue",
		"SortByEfficiency": "By efficiency",
		"SortByName": "Name",
		"SortByQualification": "Qualification",
		"SortByRating": "Rating",
		"SortByRed": "Red",
		"SortByStage": "Stage",
		"SortByState": "State",
		"SortBySumRating": "Sum rating",
		"SortByWeight": "Weight",
		"SortByWinner": "Winner",
		"SportCategory": "Sport category",
		"Stage": "Stage",
		"State": "State",
		"States": "States",
		"SumRating": "Sum rating",
		"Table2": "Table",
		"Tournaments": "Tournaments",
		"Tournament": "Tournament",
		"WeightCategory": "Weight category",
		"Winner": "Winner",
		"Overview": "Overview",
		"VideoOfBattle": "Video of bout",
		"BattlesResults": "Battles results",
		"Jabs": "Jabs",
		"Jeb": "Jab",
		"Cross": "Cross",
		"Hook L": "Hook left",
		"Hook R": "Hook right",
		"Uppercut L": "Uppercut left",
		"Uppercut R": "Uppercut right",
		"Clinch": "Clinch",
		"J": "J",
		"C": "C",
		"LJ": "JL",
		"LC": "CL",
		"RJ": "JR",
		"RC": "CR",
		"HL": "HL",
		"HR": "HR",
		"UL": "UL",
		"UR": "UR",
		"CL": "CL",
		"Block": "Block",
		"Away": "Slip",
		"Dive down": "Bobbing",
		"Footwork": "Footwork",
		"LB": "LB",
		"RB": "RB",
		"CB": "CB",
		"B": "B",
		"U": "U",
		"N": "N",
		"W": "W",
		"P": "P",
		"P1Short": "P1",
		"P2Short": "P2",
		"P3Short": "P3",
		"P4Short": "P4",
		"P5Short": "P5",
		"P6Short": "P6",
		"P7Short": "P7",
		"P1": "Right Cheek",
		"P2": "Nose",
		"P3": "Left Cheek",
		"P4": "Chin",
		"P5": "Right Body",
		"P6": "Middle Body",
		"P7": "Left Body",
		"P1_Caption": "Right Cheek",
		"P2_Caption": "Nose",
		"P3_Caption": "Left Cheek",
		"P4_Caption": "Chin",
		"P5_Caption": "Right Body",
		"P6_Caption": "Middle Body",
		"P7_Caption": "Left Body",
		"Punches on": "Punches on",
		"Action": "Action",
		"Accurate": "Accurate",
		"Accurate2": "Accurate",
		"Accurate3": "Accurate",
		"Inaccurate": "Inaccurate",
		"Power punches": "Power punches",
		"Total punches": "Total punches",
		"Round": "Round",
		"TechnicalEvaluation": "Technical evaluation",
		"Points": "Points",
		"Country": "Country",
		"CountryName": "Country",
		"Countries": "Countries",
		"Bouts": "Bouts",
		"OrderBy": "Order by",
		"AIBACard": "AIBA card",
		"ImportData": "Import data",
		"ImportBattleOverview": "Import battle overview",
		"ImportJudgeReport": "Import judge report",
		"DeleteBattleOverview": "Delete overview",
		"DeleteJudgeReport": "Delete judge report",
		"DeleteBattleConf": "Do you really want to delete bout {0} - {1}?",
		"DeleteBattleDataConf": "Do you really want to delete overview of the bout {0} - {1}",
		"DeleteJudgeReportConf": "Do you really want to delete judge report of the bout {0} - {1}",
		"BattleStatistics": "Bout statistics",
		"EditBattleStatistics": "Edit bout statistics",
		"EditEvent": "Edit event",
		"EditEventPropIsBlank": "This field must not be empty:",
		"TimeSegment": "Time",
		"StrikesSequence": "Sequence",
		"NextTimeSegment": "Next time segment",
		"NextRound": "Next round",
		"BoutEnd": "Bout end",
		"BoutEndMsg": "Bout finished",
		"CreateBout": "Create bout",
		"AddBoxer": "Add boxer",
		"CloseBattleStatisticsConf": "There are unsaved actions in the current time segment, are you sure you want to close the dialog?",
		"Total punches accuracy": "Total punches accuracy",
		"Average number of powerful punches in one round": "Average number of powerful punches in one round",
		"Average number of total punches per round": 'Average number of total punches per round',
		"Powerful punches accuracy": 'Powerful punches accuracy',
		'Average number of jabs in one round': 'Average number of jabs in one round',
		'Jabs accuracy': 'Jabs accuracy',
		"AddJudge": "Add judge",
		"Total2": "Total",
		"Technical report": "Technical report",
		"Judge report": "Judge report",
		"Judge points": "Judge points",
		"WinType_WP": "Win on points",
		"WinType_RSC": "Referee Stops Contest",
		"WinType_WO": "Walkover",
		"WinType_ABD": "Abandon",
		"WinType_KO": "Knockout",
		"WinType_TKO": "Technical knockout",
		"WinType_UD": "Unanimous decision",
		"WinType_MD": "Majority decision",
		"WinType_SD": "Split decision",
		"WinType_DQ": "Disqualification",
		"WinType_NC": "No contest",
		"WinType_RTD": "Retired",
		"WinType_TD": "Technical decision",
		"WinType_TB": "Technical submission",
		"WinType_SUB": "Submission",
		"WinType_Overturned": "Overturned",
		"WinType_CNC": "Could Not Continue",
		"WinType": "Win type {0}:",
		"WinType2": "Win type",
		"FirstNameRU": "First name (ru)",
		"LastNameRU": "Last name (ru)",
		"BattleStatisticsGamePad": "BattleStatistics (GamePad)",
		"Hide Game pads": "Hide Game pads",
		"Show Game pads": "Show Game pads",
		"EditBout": "Edit bout",
		"All punches": "All punches",
		"Landed punches": "Landed punches",
		"All punches by types": "All punches by types",
		"All punches by type": "All punches by type",
		"Punches on target by types": "Punches on target by types",
		"Punches weight": "Punches weight",
		"Punches efficiency": "Punches efficiency",
		"Punches on target by zones": "Punches on target by zones",
		"Punches statistic": "Punches statistic",
		"Defenses maneuvers by types": "Defenses maneuvers by types",
		"Defense efficiency": "Defense efficiency",
		"Punches intensity": "Punches intensity",
		"Punches density": "Punches density",
		"Attack interval": "Attack interval",
		"Missed punches by zones": "Missed punches by zones",
		"Key indicators": "Key indicators",
		"Average number of jabs per round": "Average number of jabs per round",
		"Accurate Percent": "Accurate Percent",
		"Average number of powerful punches per round": "Average number of powerful punches per round",
		"Average number of punches per round": "Average number of punches per round",
		"Punches density (punches on target per minute)": "Punches density (punches on target per minute)",
		"Punches intensity (punches per minute)": "Punches intensity (punches per minute)",
		"Attack interval (seconds per punch)": "Attack interval (seconds per punch)",
		"Number of punches series": "Number of punches series",
		"Attack initiator": "Attack initiator",
		"Attack responses": "Attack responses",
		"Male": "Male",
		"Female": "Female",
		"Pro": "Pro",
		"Amateur": "Amateur",
		"RightSide": "Orthodox",
		"LeftSide": "Southpaw",
		"Universal": "Universal",
		"Stance": "Stance",
		"Knockdown": "Knockdown",
		"Knockdowns": "Knockdowns",
		'Draw': "Draw",
		'NumberOfRounds': 'Number of rounds',
		'NotStarted': "Not started",
		'InProgress': "In progress",
		'Finished': "Finished",
		'Canceled': "Canceled",
		'NoContest': 'No contest',
		"StartTime": "Start time (mm:ss)",
		"WinTime": "Win time (mm:ss)",
		"Records": "records",
		"Result": "Result",
		"Punches series": "Punches series",
		"CriticalPunch": "Critical punch",
		"LeftCross": "Cross left",
		"RightCross": "Cross right",
		"LeftJab": "Jab left",
		"RightJab": "Jab right",
		"LeftBlock": "Block left",
		"RightBlock": "Block right",
		"CenterBlock": "Block center",
		"Ground": "Ground",
		"Distance": "Distance",
		"Strike": "Strike",
		"Punch": "Punch",
		"Kick": "Kick",
		"Elbow": "Elbow",
		"Knee": "Knee",
		"Takedown": "Takedown",
		"Transition": "Transition",
		"Submission": "Submission",
		"Control": "Control",
		"Bobbing": "Bobbing",
		"Slip": "Slip",
		"Hit": "Hit",
		"Grapple": "Grapple",
		"Unsuccessfully": "Unsuccessfully",
		"ExitFromGround": "Exit from ground",
		"ExitFromControl": "Exit from control",
		"RoundLength": "Round length",
		'EndTimeOfGround': "End time of ground",
		'EndTimeOfControl': "End time of control",
		'StartTime2': 'Start time',
		"TimeBoutEnd": "Time bout end",
		"WinDescription": "Win description",
		"RemoveLastEvent": "Remove last event",
		"Knockdown2": "Knocked down",
		"JudgePoints": "Judge points",
		"JudgesMustBeUniq": "Judges must be unique",
		"SelectJudges": "Select all judges please",
		"SortByCountry": "Country",
		"PunchesDynamicsByRound": "Punch dynamics, ${round} round",
		"PunchesDynamics": "Impact dynamics, by intervals",
		"PunchesIntensityByTimeSec": "Impact intensity, by intervals",
		"AttackIntervalByTimeSec": "Attack interval, by intervals",
		"LandedPunchesDensityByTimeSec": "Stroke density (precise beats per minute), by intervals",
		"PunchesByTimeSecAndRound": "Punch dynamics, by rounds",
		"PunchesByTimeSec": "Dynamics of strikes (for all fights), by intervals",
		"AllButClinch": "Everything but the clinch",
		"Place": "Place",
		"UserInRaiting": "User in raiting",
		"IsPro": "Is professional",
		"Edit tournament": "Edit tournament",
		"Create tournament": "Create tournament",
		"xKO": "xKO",
		"yKO": "yKO",
		"TotalLessThan6": "Total < 6.5",
		"TotalMoreThan6": "Total > 6.5",
		"Total12": "Total 12",
		"CorrectionOfCoefficient": "Correction of coefficient",
		"AvailableTournaments": "Available tournaments",
		"AvailableWidgets": "Available widgets",
		"EndBattleMessage": "What has ended?",
		"Bout": "Bout",
		"BoutsCount": "Bouts count",
		"ShowOnlyParticipantsOfTournaments": "In the list of boxers show only participants of selected tournaments",
		"PhotoUrl": "Photo link",
		"AvatarUrl": "Avatar Url",
		"FlagUrl": "Flag image link",
		"AthleteWidgets": "Fighter's widgets",
		"BattleWidgets": "Bout's widgets",
		"BattleWidgetsBox": "Boxing",
		"BattleWidgetsMMA": "MMA",
		"MMAAthleteProfileReport_StrikeType": "Strike type",
		"MMAAthleteProfileReport_Position": "Position",
		"MMAAthleteProfileReport_DefensesTypes": "Defense types",
		"MMAAthleteProfileReport_StrikesAccuracyCaption": "1. Strikes",
		"MMAAthleteProfileReport_StrikesTypesCaption": "2. Thrown strike types",
		"MMAAthleteProfileReport_LandedStrikesTypesCaption": "3. Landed strike types",
		"MMAAthleteProfileReport_StrikesEfficiencyCaption": "4. Strikes efficiency",
		"MMAAthleteProfileReport_StrikesSpeedCaption": "5. Strikes intensity",
		"MMAAthleteProfileReport_StrikesSpeedAllCaption": "Thrown strikes per minute",
		"MMAAthleteProfileReport_StrikesSpeedLandedCaption": "Landed strikes per minute",
		"MMAAthleteProfileReport_StrikesZonesCaption": "6. Strikes zones",
		"MMAAthleteProfileReport_StrikesZonesCaptionThrown": "Thrown",
		"MMAAthleteProfileReport_StrikesZonesCaptionLanded": "Landed",
		"MMAAthleteProfileReport_TakedownsAccuracyCaption": "7. Takedowns",
		"MMAAthleteProfileReport_PositionTimeCaption": "8. Position time",
		"MMAAthleteProfileReport_ControlCaption": "9. Control",
		"MMAAthleteProfileReport_DefensesTypesCaption": "10. Defenses types",
		"MMAAthleteProfileReport_DefensesEfficiencyCaption": "11. Defenses efficiency",
		"MMAAthleteProfileReport_missedStrikesZonesCaption": "12. Missed strikes zones",
		"MMAAthleteProfileReport_TakedownsDefenseCaption": "13. Takedowns defense efficiency",
		"MmaPunchesBodyView_Head": "Head",
		"MmaPunchesBodyView_Torso": "Body",
		"MmaPunchesBodyView_Legs": "Leg",

		"Age": "Age",
		"ArmSpan": "Arm span",
		"WinRecord": "WIN",
		"DrawRecord": "DRAW",
		"LoseRecord": "LOSE",
		"BaseStyle": "Base style",
		"HeightAthlete": "Height",
		"Record": "Record",
		"Event": "Event",
		"Start": "Start",
		"ExtraPoints": "Extra points",
		"Penalty": "P",
		"Damage": "Damage",
		"Dominance": "Dominance",
		"Other": "Other",
		"EndRound": "End round",

		"RoundPoints": "Round points",

		'ShowData': 'Show data',
		'Pause': 'Pause',

		'Funny': 'Funny',

		"Fail": "Fail",
		"Neck": "Neck",
		"Leg": "Leg",
		"Hand": "Hand",

		"IsGlobal": "Is global?",
		"StartView": "Start view",
		"IsOffline": "IsOffline",
		"IsDefense": "Is defense?",
		"EventName": "Event",
		"Buy": "Buy",
		"InsufficientFunds": "Insufficient funds",
		"AdditionalParameters": "Additional parameters",
		"Calculate": "Calculate",
		"ShowGRating": "Show players rating",
		"Statistics": "Statistics",
		"Events": "Events",
		"BattleCount": "Battle count",
		"SeePlayers": "Show players",
		"PlayersCount": "Players count",
		"Balance": "Balance",
		"Player": "Player",
		"Rules": "Rules",
		"Compare": "Compare",

		"StatisticsSimple": "Statistics simple",

		"Athlete": "Athlete",
		"AddAthlete": "Add athlete",
		"Nickname": "Nickname",
		"Weight": "Weight (kg)",
		"HideStat": "Hide Statistics",
		"HideCancelled": "Hide Cancelled",
		"StatisticsMaincard": "Statistics Maincard",
		"DeleteAthleteConf": "Do you really want to delete athlete {0} ?",
		"FightHistory": "Fight History",
		"History": "History",
		"FantasyRating": "Rating",
		"ViewCalc": "View calc",
		"MMARating": "MMA Rating",
		"RatingValue": "Value",
		"Strikes": "Strikes",
		"LandedStrikes": "Landed strikes",
		"Wins": "Wins",
		"SubmissionTotal": "Submission total",
		"SubmissionSuccess": "Submission success",
		"TakedownCount": "Takedown count",
		"TakedownCountSuccess": "Takedown count success",
		"StrikesPerMin": "Strikes per min",
		"StrikesLandedPerMin": "Landed strikes per min",
		"Additional1": "Winning method (These points will be awarded if the winning method fights the results of the fight)",
		"Additional2": "Additional advantages of the fighter (For the selected indicators, the player can get points with a coefficient of 1.5)",
		"StartEvent": "Start event",
		"EventIsEnd": "Event completed",

		"TakedownCountAvg5": "Number of takedowns attempts per round",
		"TakedownCountSuccessAvg5": "Number of successful takedowns per round",
		"SubmissionCountAvg5": "Number of submission attempts per round",
		"SubmissionCountSuccessAvg5": "Number of successful submission per round",
		"EfStrikes": "Impact efficiency %",
		"IntensityStrikes": "Intensity strikes",

		"Staredown": "Staredown",
		"Walkout": "Walkout",
		"ShowRespect": "Show respect",
		"AddHighlight": "Add highlight",
		"Winning": "Winning",
		'Gong': 'Gong',

		"WorldTime": "World time",
		"BattleCancelled": "Cancelled",
		"Opponent": "Opponent",

		"ExportBattles": "Export battles",
		"ExportAthletes": "Export athletes",
		"Rating2": "Rating",
		"Location": "Location",
		"RoundEnd": "Round end",
		"Locations": "Locations",
		"UTCTime": "UTC Time",

		"KickBoxers": "Kickboxers",
		"Ended": "Ended",
		"FilterAthleteByTournament": "Filter athlete by tournament",
		"SiteNoIndexEvent": "Do not index fight pages on statsfight.com until each bout is finished (event stays public)",
		"BoutAnalyze": "Bout analyze",

		"TimeBoutStart": "Time bout start",
		"Union": "Union with...",

		"VideoStartTime": "Time of the beginning of the battle in the video file",
		"VideoWorldStartTime": "Datetime of start video file (UTC)",
		"RelativeVideoStartTime": "Relative video start time",
		"PathToVideoFile": "Path to video file",
		"Stat": "Stat",

		"SponsorLogo": "Sponsor logo (url)",
		"PromoLogo": "Promo logo (url)",
		"Background": "Background (url)",

		"StartRecord": "Start record",
		"StopRecord": "Stop record",
		"StreamUrl": "Stream url",
		"VideoStream": "Video stream",
		'Message': 'Message',
		'VideoStreamUrl': 'Video stream url',
		'AddFilters': 'Additional filters',

		'ChooseWidget': 'Choose widget',
		'PreviewType': 'Preview type',
		'DetectingVideoFormat' : 'Detecting video format...',
		'HLType': 'Highlight type:',

		'WidgetAthleteName': 'Custom athlete name',
		'LogoLeftTop': 'Logo left top',
		'LogoRightBottom': 'Logo right bottom',
		'FighterStatWidget': 'Fighter stat widget',
		'FighterRecordWidget': 'Fighter record widget',
		'PeriodType' :'Period type',
		'LastYear': 'Last year',
		'LastN': 'Last N years...',
		'Open': 'Open',
		'FontFamily': 'Font Family',
		'FontColor': 'Font color',

		'ClearAllBattleData': 'Clear all battle data',
		'ManageBattleList' : 'Manage battle list',
		'SelectTheBattle': 'Select the battle',

		'FighterCompareStatWidget' :'Fighter compare Stat Widget',
		'FighterCardStatWidget': 'Fighter Card',
		'RightLogo': 'Right logo',
		'Title': 'Title',
		'LeftLogo': 'Left logo',

		'Duplicate': 'Duplicate',
		'Period': 'Period',
		'Map': 'Map',
		'SelectFile': 'Select file',
		'FighterCompareWidget': 'Fighter Compare Widget',

		"From": "From",
		"To": "To",
		"Logo": "Logo",

		'ShowOnVideo': 'Show on video',
		'Transitions': 'Transitions',


		'Trainers': 'Trainers',
		'AddTrainer': 'Add trainer',
		'Trainer': 'Trainer',
		'Education': 'Education',
		'SportClub' : 'Sport club',
		'Info': 'Info',
		'WorkStartDate': 'Carier start',

		'StudentCount': 'Athletes',
		'WorldChampions': 'World champions',
		'EuroMedalist': 'European Championship Winners',
		'RUMedalist': 'Prize-winners of the Russian Federation',
		'SportClubs': 'Sport clubs',
		'Achievements': 'Achievements',
		'Category': 'Category',

		'SP': 'МС',
		'HMS': 'ЗМС',
		'IMS': 'ММС',
		'CIS': 'КМС',

		'Adult1': 'Взрослый 1',
		'Adult2': 'Взрослый 2',
		'Adult3': 'Взрослый 3',
		'Youth1': 'Юношеский 1',
		'Youth2': 'Юношеский 2',
		'Youth3': 'Юношеский 3',

		'Experience': 'Experience (years)',

		'DeleteVideo': 'Delete video',
		'CloseTheStreamConfirm': 'Stream recording will continue. Close the dialog?',

		'PrevSec': 'Prev sec',
		'NextSec': 'Next sec',
		'FromStart': 'From start',
		'FromPoint': 'From point',

		'Add': 'Add',
		'SwapData': 'Swap the data',
		'ChangeCorners': 'Change corners',

		'MoveBottom': 'Move bottom',
		'MoveTop': 'Move top',
		'RecordInfo': 'Record',
		'Share': 'Share',
		'Favorite': 'Favorite',

		'WinRound': 'Win round',
		'LogoUrl': 'Logo url',
		'EventDate': 'Event Date'
	}
};

try
{
	// @ts-ignore
	if (window.numeral) numeral.locale(NP._currentCulture.Name);
	// @ts-ignore
	if (window.moment) moment.locale('en');
} catch (e)
{
}
